export default {
  feederTypes(state) {
    return state.feederTypes;
  },
  feederTypesForSelect(state) {
    return state.feederTypes.map((feederType) => ({
      id: feederType.value,
      text: feederType.name,
    }));
  },
  socialMediaProfileInfo(state) {
    return state.socialMediaProfileInfo;
  },
  userFeedHistory(state) {
    return state.userFeedHistory;
  },
  operationFeederNotes(state) {
    return state.operationFeederNotes;
  },
};
